'use client';

import type { CSSProperties } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';

import styles from './Label.module.scss';

export type LabelType = BaseComponentProps & {
  value: string | number;
  backgroundColor?: string;
};

function Label({
  style,
  className,
  value,
  backgroundColor = '#fabc99',
  testId = 'ui-list-item',
}: LabelType) {
  return (
    <div
      style={
        {
          ...style,
          backgroundColor,
        } as CSSProperties
      }
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      <span className={styles['label']}>{value}</span>
    </div>
  );
}

export { Label };
